var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.5,25c0,1.59-1,2.43-2.33,3.05Q34.11,33.13,23.08,38.23L7.36,45.47c-.36.17-.73.32-1.09.48a2.51,2.51,0,0,1-2.92-.56,2.45,2.45,0,0,1-.61-2.91c2-4.53,4-9.06,6.06-13.53a3.19,3.19,0,0,1,2.13-1.48c4.07-.48,8.16-.78,12.25-1.12.89-.08,1.8-.23,1.82-1.3s-.94-1.33-1.87-1.41C19.05,23.29,15,23,10.89,22.51A3.12,3.12,0,0,1,8.78,21c-2.1-4.43-4-8.93-6-13.41a2.5,2.5,0,0,1,.61-3,2.73,2.73,0,0,1,3.3-.37q9.06,4.2,18.12,8.36Q35,17.26,45.21,21.94A3.25,3.25,0,0,1,47.5,25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.771b3671652378bfcead33ae090f4bca.svg";
export { ForwardRef as ReactComponent };